import { Pagination as MUIPagination, paginationItemClasses, styled } from '@mui/material';
export const Pagination = styled(MUIPagination)(({ theme }) => {
    return {
        [`& .${paginationItemClasses.root}`]: {
            border: 'none',
            borderRadius: 4,
            fontSize: theme.typography['uikit-subheader3'].fontSize,
            fontWeight: 400,
            [`&.${paginationItemClasses.selected}`]: {
                backgroundColor: 'unset',
                border: `1px solid ${theme.palette.primary.main}`,
                fontWeight: 500,
            },
        },
    };
});
